import controller from './searchbar.controller';
import template from './searchbar.html';

const searchbarComponent = {
  restrict: 'E',
  bindings: {
    searchTerms: '=',
    searchText: '=',
    isDisabled: '=',
    searchPlaceholder: '@',
    onSearch: '&',
    minLengthForSearch: '<'
  },
  template,
  controller
};

export default searchbarComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/searchbar/searchbar.component.js
 **/